import { render, staticRenderFns } from "./TotalCosts.vue?vue&type=template&id=14f6cb53&scoped=true"
import script from "./TotalCosts.vue?vue&type=script&lang=js"
export * from "./TotalCosts.vue?vue&type=script&lang=js"
import style0 from "./TotalCosts.vue?vue&type=style&index=0&id=14f6cb53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f6cb53",
  null
  
)

export default component.exports